import React, { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { ListView, TableAction } from '../../components';
import { userList } from '../../config/layouts/user';
import useAPI from '../../../utils/useApi';
import { APIRequests } from '../../../config/api';
import { RequestInput } from '../../../types';
import { useNavigate } from 'react-router-dom';

export const UserList = () => {
  const navigate = useNavigate();
  const checkStatus = useAPI(APIRequests.AdminCheckOrderStatus);
  const executeOrderAutomation = (): JSX.Element => {
    return (
      <Button
        key="execute-button"
        variant="contained"
        onClick={() => alert('To be implemented')}
      >
        Execute Order Automation
      </Button>
    );
  };
  const userListActions: JSX.Element[] = [executeOrderAutomation()];
  const handleCheckOrderStatus = (_: number, data: any | undefined) => {
    const req: RequestInput = { body: { recordid: data.id } };
    checkStatus.execute(req);
  };

  useEffect(() => {
    if (checkStatus.data) {
      const d = checkStatus.data as any;
      alert(`Result: ${d.vitamin_production_status}`);
    }
  }, [checkStatus.data]);

  const userTableActions: TableAction[] = [
    {
      header: 'Check Order Status',
      onClick: handleCheckOrderStatus,
      icon: 'shieldCheck',
    },
    {
      header: 'Inspect Algorithm',
      onClick: (_: number, data: any | undefined) => {
        navigate(`/admin/algorithm?email=${data.email}`);
      },
      icon: 'shieldCheck',
    },
  ];

  const props = {
    title: userList.title,
    tableProps: {
      columns: userList.columns,
      emptyMessage: <Typography>{userList.emptyMessage} </Typography>,
      actions: userTableActions,
    },
    apiRequest: userList.apiRequest,
    actions: userListActions,
  };
  return <ListView {...props} />;
};
